import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-customertest",
  templateUrl: "./customertest.component.html",
  styleUrls: ["./customertest.component.scss"],
})
export class CustomertestComponent implements OnInit {
  data = [
    {
      logo1: "../../assets/images/testimonials/mvijay2.PNG",
      logo2: "../../assets/images/testimonials/mvijay1.PNG",
      title: "Mrs. Nikita Vijay & Mr. Murali Vijay, Chennai",
      description:
        "I was looking to design my weekend home and I needed something quirky and out-of-the-box. I wanted a place to unwind and wanted it to be sporty and functional.  Bricks And Beams was my obvious choice. I've worked with them previously and I'm aware of their working model. Most importantly I can trust them wholeheartedly with their project execution style as they get very eclectic when it comes to designing a space differently. Their aesthetics and thought processes are different and they go beyond their limits to bring the desired output.  I would strongly recommend Bricks And Beams if you are looking for an interior design partner for your homes.",
    },
    {
      logo1: "../../assets/images/testimonials/ashwinr1.PNG",
      logo2: "../../assets/images/testimonials/ashwinr2.PNG",
      title: "Mrs. Prithi Ashwin & Mr. Ashwin R, Chennai",
      description:
        "Bricks And Beams understood the pulse of our requirement with regard to transforming our home into something beautiful and functional. They were able to understand our perspectives effectively and delivered what was necessary. Our home looks absolutely stunning and elegant post the transformation. Thanks to their creative touch. Team Bricks and Beams is best in town and they are focused & dedicated to their deliverables which is their plus. They went extra mile in sticking to the delivery date they promised. They can be your trusted interior partners any day.",
    },
    {
      logo1: "../../assets/images/testimonials/sangeetha1.PNG",
      logo2: "",
      title: "Mrs. Sangeetha Parthasarathy, \nChennai",
      description:
        " I looked them up on Insta and I loved their work straight away. … we trusted them so much… No Micromanagement whatsoever. And I m amazed at what’s come out of it. …I gave complete, Full creative liberty to design the house. That came from us knowing that they knew us as a couple and wanted to tell our story through design…   … If you want someone who could push your  boundaries, offbeat, very unique that you wont see it anywhere else…If you want somebody to just trust and let them get on with it, just go for Bricks And Beams",
    },

    {
      logo1: "../../assets/images/testimonials/radhika1.PNG",
      logo2: "",
      title: "Mrs. Radhika Krish, \nChennai",
      description:
        "we engaged Bricks And Beams for a minimalistic transformation in our house. Boy they did a fantastic job. The conceptualized our stairway that travels to predominately most of the parts of our house with all our collectibles that travelled along with our families over generation.  That is my favorite spot of the house. I always pause and soak it all in every time I go up or come down. Thanks for making my vision come alive team Bricks And Beams.",
    },
    {
      logo1: "../../assets/images/testimonials/image1.PNG",
      logo2: "",
      title: "MR. Hariharan & Family, \nChennai",
      description:
        "We are a family of four with humble and rooted backgrounds… we wanted an aspirational interior designers to work on our dream home. We found about Bricks And Beams through their social media page … and approached them for their services. Their unique working style and design language coincided with ours. Their efficient and passionate style of working were their USP. We had a great working relationship with them and would like to collaborate with them on future projects as well.",
    },
    {
      logo1: "../../assets/images/testimonials/project6.jpeg",
      logo2: "",
      title: "Mr Harikrishna & Mrs Aarti Harikrishna, Coimbatore",
      description:
        "Loved their work. Quintessential ❤️ Highly recommend them. Artistic, easy to work with and communicate ur ideas. They put a lot of effort to make a house into ur home 🙂 \n\n Positives:Professionalism, Punctuality, Quality, Responsiveness, Value",
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
